module.exports = __webpack_public_path__ + "static/media/status_approved.fe951cd5.svg";